import { render, staticRenderFns } from "./PantallaFinal.vue?vue&type=template&id=02622887&"
import script from "./PantallaFinal.vue?vue&type=script&lang=js&"
export * from "./PantallaFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports